import { Content } from "@/components/layouts/content";
import { checklistQueryOptions } from "@/features/dashboard/api/queries/checklist-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/checklists_/$checklistId")({
	component: Page,
});

function Page() {
	const { checklistId } = Route.useParams();

	const checklistQuery = useQuery(checklistQueryOptions(checklistId));

	if (checklistQuery.isLoading) {
		return (
			<Content pageName="Checklist Details">
				<div className="flex items-center justify-center h-64">
					<div className="text-center">
						<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto" />
						<p className="mt-2 text-sm text-gray-600">Loading checklist...</p>
					</div>
				</div>
			</Content>
		);
	}

	const checklist = checklistQuery.data;

	if (!checklist) {
		return (
			<Content pageName="Checklist Details">
				<div className="flex items-center justify-center h-64">
					<div className="text-center">
						<p className="text-gray-600">Checklist not found</p>
					</div>
				</div>
			</Content>
		);
	}

	return (
		<Content pageName="Checklist Details">
			<div className="flex flex-col h-full">
				{/* Upper section - Checklist details */}
				<div className="bg-white border-b p-6">
					<div className="max-w-4xl mx-auto">
						<div className="flex items-start justify-between">
							<div className="flex-1">
								<h1 className="text-2xl font-bold text-gray-900">{checklist.name}</h1>
								<p className="mt-1 text-sm text-gray-600">{checklist.description || "No description"}</p>

								<div className="mt-4 flex flex-wrap gap-4">
									<div className="flex flex-col">
										<span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Category</span>
										<span className="mt-1 inline-flex px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">{checklist.category}</span>
									</div>

									{checklist.project && (
										<div className="flex flex-col">
											<span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Project</span>
											<span className="mt-1 text-sm font-medium text-gray-900">{checklist.project.name}</span>
											<span className="text-xs text-gray-600">
												{checklist.project.client} • {checklist.project.status}
											</span>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Lower section - Future expansion for checklist items, etc. */}
				<div className="flex-1 overflow-hidden">
					<div className="h-full bg-gray-50 p-6">
						<div className="max-w-4xl mx-auto">
							<div className="bg-white rounded-lg shadow p-6">
								<h2 className="text-lg font-semibold text-gray-900 mb-4">Checklist Details</h2>
								<p className="text-gray-600">
									This is where checklist items and detailed information would be displayed. Future development will include checklist item management,
									completion tracking, and reporting features.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Content>
	);
}
